import { LoadingButton } from "@mui/lab";
import { Autocomplete, Card, CardActions, CardContent, CardHeader, Divider, Grid, TextField, Typography } from "@mui/material";
import { get } from "lodash";

import { useTranslation } from "react-i18next";

import { useGetBanksQuery } from "src/_api/bankApi";
import { MapItTextField } from "src/components/common";
import { ROLES, USER_ROLES_TYPES } from "src/constants";

export default function ProfileBusinessInfoCard({
    // role,
    // type,
    bankInformation,
    onChange,
    validationErrors,
    onUpateProfile,
    loading,
    isSuccess,
    error
}) {
    const { t, i18n } = useTranslation();

    const { data: banks, isLoading: banksLoading } = useGetBanksQuery();

    // console.log(banks?.find(bank => bank?.id === bankInformation?.bank));

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Bank Account Info")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <Grid container spacing={3} alignContent="center">
                    <Grid item xs={12} md={12}>
                        <Autocomplete
                            fullWidth
                            getOptionLabel={(option) => get(option, i18n.dir === "rtl" ? "name_ar" : "name_en") || ""}
                            onChange={(event, newValue) => onChange({ target: { name: "bankInformation.bank", value: newValue?.id } })}
                            value={banks?.find(bank => bank?.id == bankInformation?.bank) ?? null}
                            size="small"
                            loading={banksLoading}
                            loadingText={t("loading data...")}
                            options={banks ?? []}
                            renderInput={(params) => <TextField {...params}
                                label={t("Bank")}
                                error={!!validationErrors?.bank ?? ""}
                                helperText={validationErrors?.bank ?? ''}
                                required={true}
                            />}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <MapItTextField
                            label={t("Account Holder Name")}
                            size="small"
                            name="bankInformation.accountName"
                            value={bankInformation?.accountName ?? ""}
                            required={true}
                            handleChange={onChange}
                            error={validationErrors?.accountName ?? ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <MapItTextField
                            label={t("IBAN")}
                            size="small"
                            name="bankInformation.iban"
                            value={bankInformation?.iban ?? ""}
                            required={true}
                            handleChange={onChange}
                            error={validationErrors?.iban ?? ""}
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <Divider />
            <CardActions sx={{
                display: "flex",
                justifyContent: error || isSuccess ? "space-between" : "flex-end",
                alignItems: 'center',
            }}>
                {error && <Typography color='text.danger'>{t(error)}</Typography>}
                {isSuccess && <Typography color='success.main'>{t("Done successfully")}</Typography>}
                <LoadingButton
                    // disabled={role === ROLES.admin || type === USER_ROLES_TYPES.SUB_ADMIN}
                    variant="contained"
                    loading={loading}
                    onClick={onUpateProfile}>
                    {t("Update")}
                </LoadingButton>
            </CardActions>
        </Card>
    )
}
